import { v4 as uuid } from "uuid";
import type { SupabaseClient } from "@supabase/supabase-js";

export const getSignedUrl = async (
  supabaseClient: SupabaseClient,
  bucketName: string,
  path: string,
  download?: string
): Promise<string> => {
  const { data, error } = await supabaseClient.storage
    .from(bucketName)
    .createSignedUrl(path, 60 * 60 * 1, { download }); // 1 hour expiry

  if (error) {
    console.error(`muly:getSignedUrl ${error.message}`, { error: error.stack });
    throw error;
  }
  if (!data || !data.signedUrl) {
    throw new Error(`getSignedUrl failed, data.signedURL is empty`);
  }
  return data.signedUrl;
};

export const uploadFile = async (
  supabaseClient: SupabaseClient,
  file: File,
  userId: string
): Promise<string> => {
  const bucketName = "customer_documents";
  console.log(`muly:uploadFile to ${bucketName}`, { file, userId });
  const { data, error } = await supabaseClient.storage
    .from(bucketName)
    // .from("tmp")
    .upload(`${userId}/${uuid()}`, file);

  console.log(`muly:uploadFile to ${bucketName} AFTER`, { file, userId, data });
  if (error) {
    console.error(`muly:uploadFile ${error.message}`, { error });
    throw error;
  }

  if (!data || !data.path) {
    throw new Error(`upload to bucket failed, data.Key is empty`);
  }

  // const fulPath = await getSignedUrl(supabaseClient, bucketName, data.path);
  console.log(`muly:uploadFile`, { data, file });
  return JSON.stringify({
    bucketName,
    path: data.path,
    secure: true,
    name: file.name,
    type: file.type,
    ext: file.name.split(".").pop(),
  });
};

export const maybeUploadFile = async <T>(
  supabaseClient: SupabaseClient,
  fieldName: string,
  values: T,
  id: string | null | undefined
): Promise<T> => {
  // @ts-ignore
  const file = values[fieldName];
  if (file instanceof File) {
    if (!id) {
      throw new Error(`maybeUploadFile id is empty`);
    }

    const pathToFile = await uploadFile(supabaseClient, file, id);
    // const answer = await uploadFile(certificate_id_picture, user.id, "tmp");
    console.log(`muly:handleSubmit uploadFile ${fieldName}`, {
      answer: pathToFile,
      id,
    });

    values = { ...values, [fieldName]: pathToFile };
  }

  return values;
};

export const downloadFile = async (
  supabaseClient: SupabaseClient,
  fileInfo: string | undefined | null
): Promise<string | null> =>
  new Promise<string | null>(async (resolve) => {
    if (fileInfo?.startsWith("{")) {
      const { bucketName, path } = JSON.parse(fileInfo);
      const fullPath = await getSignedUrl(supabaseClient, bucketName, path);
      const blobData = await fetch(fullPath);
      const reader = new FileReader();
      reader.onload = () => {
        const dataUrl = reader.result;
        console.log(`muly:onload`, { dataUrl });
        resolve(dataUrl ? (dataUrl as string) : null);
      };
      reader.readAsDataURL(await blobData.blob());
    } else {
      resolve(null);
    }
  });
